<template>
  <v-row v-if="$store.state.auth.checkAccess({key: 'duplicates', value: true})">
    <v-col :cols="12">
      <material-card class="mt-0" color="green" title="Duplicates">

        <v-row>
          <v-col cols="3">
            <v-label>Same Email</v-label>
            <div class="">
              <v-chip
                class="ma-1"
                v-for="d in activeAccount.account.with_same_mail"
                :key="'same-mail-' + d"
                :href="'/user-management/' + d"
                target="_blank"
                small
                link
              >
                {{ d }}
              </v-chip>
            </div>
          </v-col>
          <v-col cols="3">
            <v-label>Same Phone</v-label>
            <div class="">
              <v-chip
                class="ma-1"
                v-for="d in activeAccount.account.with_same_phone"
                :key="'same-phone-' + d"
                :href="'/user-management/' + d"
                target="_blank"
                small
                link
              >
                {{ d }}
              </v-chip>
            </div>
          </v-col>
          <v-col cols="6">
            <v-label>Duplicates</v-label>

            <div>
              <v-progress-circular
                v-if="activeAccount.duplicates.loading && (activeAccount.duplicates.login_list || []).length == 0"
                indeterminate
                color="primary"
              />

              <template v-for="d in activeAccount.duplicates.login_list">
                <v-chip
                  class="ma-1"
                  :key="'duplicates-d-' + d"
                  :href="'/user-management/' + d"
                  target="_blank"
                  small
                  dense
                  link
                >
                  {{ d }}
                </v-chip>
              </template>
              <v-chip
                v-if="(activeAccount.duplicates.login_list || []).length < (activeAccount.duplicates.items || []).length"
                class="ma-1"
                small
                @click="more()"
                dense
                link
              >
                more...
              </v-chip>
            </div>
          </v-col>
        </v-row>

      </material-card>
    </v-col>
  </v-row>
</template>

<style>
  .custom_label > label div {
    vertical-align: super;
    display: inline-block;
    cursor: pointer;
    user-select: none;
    line-height: 24px;
  }
</style>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: [],

    components: {},

    data: () => ({
      loyalty: 0,
      loading: false
    }),

    computed: {
      ...mapGetters({ activeAccount: 'account/active', infoTab: 'account/infoTab' }),
    },

    mounted () {
    },

    methods: {
      more () {
        this.$store.commit('account/setInfoTab', 'duplicates')
        window.scrollTo(0, 0)
      }
    },

  }
</script>
